import { useContext } from 'react'
import { useStore } from 'zustand'
import { StatsBoxStore } from './types'
import { StatsBoxContext } from './provider'

export function useStatsBox<T>(selector: (store: StatsBoxStore) => T): T {
  const ctx = useContext(StatsBoxContext)
  const id = 'StatsBox'

  if (ctx === undefined) {
    throw new Error(`${id} selector must be used within ${id}Provider`)
  }

  return useStore(ctx, selector)
}
